import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const HospitalInsuranceIcon = (props) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M8.33337 0.175781C8.16421 0.175781 7.99543 0.224766 7.84835 0.322266L1.22725 4.70703C0.981421 4.86953 0.833374 5.14608 0.833374 5.44108V14.1667C0.833374 15.0875 1.57921 15.8333 2.50004 15.8333H10.8822C10.8514 15.565 10.8334 15.2883 10.8334 15V11.416L15.8334 9.19434V5.44108C15.8334 5.14608 15.6853 4.87116 15.4395 4.70866L8.8184 0.322266C8.67132 0.224766 8.50254 0.175781 8.33337 0.175781ZM8.33337 5C8.79337 5 9.16671 5.37333 9.16671 5.83333V7.5H10.8334C11.2934 7.5 11.6667 7.87333 11.6667 8.33333C11.6667 8.79333 11.2934 9.16667 10.8334 9.16667H9.16671V10.8333C9.16671 11.2933 8.79337 11.6667 8.33337 11.6667C7.87337 11.6667 7.50004 11.2933 7.50004 10.8333V9.16667H5.83337C5.37337 9.16667 5.00004 8.79333 5.00004 8.33333C5.00004 7.87333 5.37337 7.5 5.83337 7.5H7.50004V5.83333C7.50004 5.37333 7.87337 5 8.33337 5ZM16.25 10.8333C16.1463 10.8334 16.0423 10.8554 15.9457 10.9017L12.946 12.3275C12.6752 12.455 12.5 12.7416 12.5 13.0583V14.6615C12.5 18.1448 15.1825 19.7708 16.25 20C17.3175 19.7708 20 18.1448 20 14.6615V13.0583C20 12.7416 19.8249 12.4542 19.5541 12.3258L16.5544 10.9017C16.4577 10.8559 16.3538 10.8332 16.25 10.8333Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

HospitalInsuranceIcon.propTypes = {
  sx: PropTypes.object,
};

export default HospitalInsuranceIcon;
